//React
import React from 'react';
import { withRouter } from 'react-router';
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as coupleAction from '../action/coupleAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import Checkbox from '@material-ui/core/Checkbox';

//Icon
import CloseIcon from '@material-ui/icons/Close';


class Comp extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      checkBool: false,
      checkName: null,
      checkComment: null,
      confirm: false,
      datetime: null,
  	}
  }


  componentDidUpdate(prevProps, prevState) {
    if (this.props.open !== prevProps.open && this.props.open === true) {
      this.props.coupleRequestCheck(this.props.pic, (data) => {
        this.setState({
          checkBool: data.bool,
          checkName: data.name,
          checkComment: data.comment,
          datetime: (new Date()),
        })
      });
    }
  }

  _submit() {
    this.props.coupleRequestAdd(this.props.pic, (data) => {
      if (data.bool) {
        this.props.history.push('/coupleRequestEnd/');
      }
    });
    this.props.close();
  }

	render() {
		return (
    <div>
			<Dialog
        open={this.props.open}
        maxWidth='xs'
      >
        {
          (this.state.datetime) && (
            <div>
              <div
                style={{
                  display:'flex',
                  flexDirection:'row',
                  alignItems:'center',
                  justifyContent:'space-between',
                }}
              >
                <div style={{fontSize:'1.1em',fontWeight:'bold',margin:'15px'}}>
                  {this.state.checkName} さんへカップリングのお申し込み
                </div>
                <IconButton
                  onClick={ () => {
                    this.props.close();
                    this.setState({confirm: false});
                  }}
                >
                  <CloseIcon/>
                </IconButton>
              </div>
              <div style={{padding:'10px'}}>
                <div style={{margin:'10px'}}>
                  カップリングとはライバルが現れない環境でお二人の関係を築いていただく機能です
                </div>

                <ul>
                  <li style={{marginLeft:'2em'}}>
                    2人とも検索結果にプロフィールが表示されなくなります
                  </li>
                  <li style={{marginLeft:'2em'}}>
                    2人ともプロフィールにカップリング中と表示されます
                  </li>
                </ul>

                <div align='center' style={{margin:'15px'}}>
                  <Button
                    color="primary"
                    variant={ "outlined" }
                    onClick={ () => this.props.helpOpen('category','couple') }
                  >
                    「カップリング」について
                  </Button>
                </div>

                {
                  (this.state.checkBool) ? (
                    <div>
                      <div style={{margin:'10px'}}>
                        真剣な交際に向けてカップリングする事に同意いただけますか？
                        <Checkbox
                          checked={this.state.confirm}
                          onChange={ () => this.setState({confirm: (this.state.confirm) ? false: true })}
                          color="primary"
                        />
                      </div>

                      <div align='center' style={{padding:'10px'}}>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{minWidth:'200px'}}
                          onClick={ () => this._submit() }
                          disabled={ this.state.confirm ? false: true }
                        >
                          <span style={{fontSize:'1.2em'}}>カップリングを申し込む</span>
                        </Button>
                      </div>
                    </div>
                  ) : (
                    <div style={{color:'red'}}>{this.state.checkComment}</div>
                  )
                }
              </div>
            </div>
          )
        }
			</Dialog>
    </div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...coupleAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Comp));
